import React from 'react';

const BaseUniversoTabla = ({nombreBaseUniversoProspectosSectorCliente, baseUniversoProspectosSectorCliente}) => {

    
    const styles = {
        cell: {
            minWidth: '150px',
            whiteSpace: 'nowrap',
            overflowX: 'auto',
        },
    };
    
  return (
    <>
            {/* alerta ?  (<div className={`alerta ${alerta.categoria}`}> {alerta.msg} </div>) : null*/}
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='table-responsive'>
                            <div className="table-container">
                                <table className='table-hover table-bordered'>
                                    <thead>
                                        <tr>
                                            <th style={styles.cell}>N°</th>
                                            <th>Prospecto</th>
                                            <th>Sector</th>
                                        </tr>
                                    </thead>
                                        <tbody>
                                            {(nombreBaseUniversoProspectosSectorCliente) ?
                                                baseUniversoProspectosSectorCliente.map((item, i) => {
                                                    return(
                                                        <tr key={i+1}>
                                                            <td><p>{i +1}</p></td>
                                                            <td>{item.desc_prs_prospecto}</td>
                                                            <td>{item.desc_prs_sector}</td>
                                                            
                                                        </tr>
                                                    )
                                                })
                                            : null
                                            }
                                        </tbody>
                                </table>
                            </div>
                    </div>
                </div> {/* fin div para la tabla */}
            </div>
        </>
  )
}

export default BaseUniversoTabla;